<div class="container-fluid contentHeight">
    <div class="admCommandeCtn">
        <h1 class="text-center containerTitle">Gestion des achats commandes</h1>
        <nav>
            <div class="nav nav-tabs  bg-light" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-devis-tab" data-toggle="tab" role="tab" aria-controls="nav-devis" aria-selected="false" (click)="toggleTab('1', 'nav-devis','nav-devis-tab')">Demande de devis</a>
                <a class="nav-item nav-link" id="nav-stat4-tab" data-toggle="tab" role="tab" aria-controls="nav-stat4" aria-selected="false" (click)="toggleTab('4', 'nav-stat4','nav-stat4-tab')">Virements bancaires/Chèques</a>
                <a class="nav-item nav-link" id="nav-stat5-tab" data-toggle="tab" role="tab" aria-controls="nav-stat5" aria-selected="false" (click)="toggleTab('5', 'nav-stat5','nav-stat5-tab')">Dossiers complétés</a>
            </div>
        </nav>
        <div class="tab-content adminContent flex flex-column flex-grow-1" id="nav-tabContent">
            <div class="row bg-light noMargin filter">
                <div class="col-6">
                    <mat-form-field class="ml-2">
                        <mat-label>Rechercher</mat-label>
                        <input matInput [value]="valSearch" (change)='valSearch=$event.target.value' (keyup)="applyFilter($event.target.value)">
                    </mat-form-field>
                    <mat-checkbox [checked]="conserverRecherche" (change)="changeFlagConserverRecherche()">Conserver recherche</mat-checkbox>

                </div>
                <div class="col-6">
                    <div class="text-right"> <i aria-hidden="true" (click)="refreshTab()" class="fas fa-sync  fa-1-2x p-2" style="color:steelblue; cursor:pointer;"></i> </div>
                </div>
            </div>

            <div class="tab-pane noOverflow fade show active position-relative flex-grow-1" id="nav-stat4" role="tabpanel" aria-labelledby="nav-stat4-tab">
                <mat-table class="table lstdossier bg-white table-hover" matSort [dataSource]="orderSource" (matSortChange)="sortScale($event,'1')">
                    <!-- Champs Mouvement -->
                    <ng-container matColumnDef="mouvement">
                        <mat-header-cell *matHeaderCellDef> Mouvement </mat-header-cell>
                        <mat-cell *matCellDef="let res">
                            <div *ngIf="res.activationStatus == 5">
                                <div *ngIf="res.isChecked == 0">
                                    <input type="checkbox" id="res.activationID"
                                           (ngModelChange)="onIsCheckedChange(res.activationID)">
                                </div>
                                <div *ngIf="res.isChecked == 1">
                                    <input type="checkbox" checked="checked" id="res.activationID"
                                           (ngModelChange)="onIsCheckedChange(res.activationID)">
                                </div>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <!-- Champs Numéro de commande -->
                    <ng-container matColumnDef="orderNumber">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>N° de commande</mat-header-cell>
                        <mat-cell *matCellDef="let res">{{res.orderNumber}}</mat-cell>
                    </ng-container>
                    <!-- Champs Date de commande -->
                    <ng-container matColumnDef="orderDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Date de la commande</mat-header-cell>
                        <mat-cell *matCellDef="let res">{{res.transDate | date:'dd/MM/yyyy'}}</mat-cell>
                    </ng-container>
                    <!-- Champs codeUnisite -->
                    <ng-container matColumnDef="codeUnisite">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Code Unisite</mat-header-cell>
                        <mat-cell *matCellDef="let res">
                            {{res.unisiteCode}}
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Raison sociale -->
                    <ng-container matColumnDef="socialReason">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Raison sociale</mat-header-cell>
                        <mat-cell *matCellDef="let res">
                            {{res.adresseFacturation.socialReason}}
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Pays -->
                    <ng-container matColumnDef="country">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Pays</mat-header-cell>
                        <mat-cell *matCellDef="let res">
                            {{res.adresseFacturation.country}}
                        </mat-cell>
                    </ng-container>
                    <!-- Champs nombre produits -->
                    <ng-container matColumnDef="nbProducts">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Nombre de produits</mat-header-cell>
                        <mat-cell *matCellDef="let res">{{res.nbProducts}}</mat-cell>
                    </ng-container>
                    <!-- Champs Montant de la commande -->
                    <ng-container matColumnDef="amount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Montant de la commande</mat-header-cell>
                        <mat-cell *matCellDef="let res">{{res.amountTotal}} €</mat-cell>
                    </ng-container>
                    <!-- Champs Code SAGE -->
                    <ng-container matColumnDef="sageCode">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Code SAGE </mat-header-cell>
                        <mat-cell *matCellDef="let res"> {{res.sageCode}} </mat-cell>
                    </ng-container>
                    <!-- Champs Numéro de facture -->
                    <ng-container matColumnDef="facture">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Numéro de facture</mat-header-cell>
                        <mat-cell *matCellDef="let res">
                            <span *ngIf="!res.invoiceCode">
                                <i aria-hidden="true" class="fad fa-file-invoice fa-1-2x " style=" --fa-primary-color: #e0003c ; --fa-secondary-color: #e8641b;"></i>
                            </span>
                            <span *ngIf="res.invoiceCode"> {{res.invoiceCode}} </span>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Editer -->
                    <ng-container matColumnDef="finalEdit">
                        <mat-header-cell *matHeaderCellDef>Editer</mat-header-cell>
                        <mat-cell *matCellDef="let res" class="pointer" (click)="displayInfoOrder(res.billingID)">
                            <i aria-hidden="true" class="fad fa-edit  fa-1-2x twoToneBlue"></i>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs details devis-->
                    <ng-container matColumnDef="details">
                        <mat-header-cell *matHeaderCellDef>Détails</mat-header-cell>
                        <mat-cell *matCellDef="let res" class="pointer" (click)="displayDetails(res.billingID)">
                            <i aria-hidden="true" class="far fa-info-square fa-1-2x"></i>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs devis validé-->
                    <ng-container matColumnDef="devisValide">
                        <mat-header-cell *matHeaderCellDef>Devis Validé</mat-header-cell>
                        <mat-cell *matCellDef="let res">
                            <i aria-hidden="true" *ngIf="res.transStatus == 18" class="fas fa-check fa-1-2x green"></i>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs En attente de paiement -->
                    <ng-container matColumnDef="waitPayment">
                        <mat-header-cell *matHeaderCellDef>En attente de paiement</mat-header-cell>
                        <mat-cell *matCellDef="let res">
                            <span class="fa-1-2x paymentWaiting">
                                <i aria-hidden="true" class="far fa-money-bill-alt fa-1-2x " style="color:darkslategrey"></i>
                                <i aria-hidden="true" class="fad fa-clock fa-xs" style="color:Red"></i>
                            </span>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Accepter le virement -->
                    <ng-container matColumnDef="paymentInfo">
                        <mat-header-cell *matHeaderCellDef>Accepter le virement</mat-header-cell>
                        <mat-cell *matCellDef="let res" (click)="displayPayementInfo(res.billingID)" class="pointer">
                            <i aria-hidden="true" class="far fa-badge-check fa-1-2x"></i>
                        </mat-cell>
                    </ng-container>
                    <!-- Champs Notification d'envoi  -->
                    <ng-container matColumnDef="deliveryNotification">
                        <mat-header-cell *matHeaderCellDef>Notification envoi</mat-header-cell>
                        <mat-cell *matCellDef="let res">
                            <i aria-hidden="true" *ngIf="!res.isSended" class="fad fa-shipping-fast fa-1-2x twoToneGreen pointer" (click)="openShippingModal(res.billingID)"></i>
                            <i aria-hidden="true" *ngIf="res.isSended" class="fas fa-check fa-1-2x green"></i>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                </mat-table>
            </div>
        </div>
    </div>
</div>

<div id="Modal" class="modal">
    <div class="modal-content" *ngIf="order">
        <div class="col-12 text-center" *ngIf="payement">
            <span class="text-right pointer close" (click)="closeModal();">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
            <h1> Validation du paiement  </h1> <hr>
        </div>
        <div class="col-12 text-center" *ngIf="facturation">
            <span class="text-right pointer close" (click)="closeModal();">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
            <h1>Informations Facturation</h1> <hr />
        </div>
        <div class="col-12 text-center" *ngIf="devis">
            <span class="text-right pointer close" (click)="closeModal();">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
            <h1>Details du devis frais de port</h1> <hr />
        </div>
        <div class="row">
            <div class="col-3 offset-3">
                <h3>  <i aria-hidden="true" class="fad fa-industry-alt" style="--fa-primary-color: #0177be; --fa-secondary-color: #3a2785;"></i> Adresse livraison</h3>
                <div class="row">
                    <div class="col-12"> <span class="font-weight-bold">Raison sociale :</span> {{ order.adresseLivraison.socialReason }}</div>
                    <div class="col-12"> <span class="font-weight-bold">Adresse :</span> {{ order.adresseLivraison.address }}</div>
                    <div class="col-12"> <span class="font-weight-bold">Ville :</span> {{ order.adresseLivraison.city}}</div>
                    <div class="col-12"> <span class="font-weight-bold">Pays :</span> {{ order.adresseLivraison.country }}</div>
                    <div class="col-12"> <span class="font-weight-bold">n° TVA intracommunautaire :</span> {{ order.adresseLivraison.tvaIntra }}</div>
                </div>
            </div>
            <div class="col-3">
                <h3>  <i aria-hidden="true" class="fad fa-industry-alt" style="--fa-primary-color: #0177be; --fa-secondary-color: #3a2785;"></i> Adresse facturation</h3>
                <div class="row">
                    <div class="col-12"> <span class="font-weight-bold">Raison sociale :</span> {{ order.adresseFacturation.socialReason }}</div>
                    <div class="col-12"> <span class="font-weight-bold">Adresse :</span> {{ order.adresseFacturation.address }}</div>
                    <div class="col-12"> <span class="font-weight-bold">Ville :</span> {{ order.adresseFacturation.city }}</div>
                    <div class="col-12"> <span class="font-weight-bold">Pays :</span> {{ order.adresseFacturation.country }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 mx-auto">
            <div class="col-10 mx-auto bg-light">
                <h3 class="pt-2"> Commande </h3>
                <table class="commande">
                    <caption></caption>
                    <thead>
                        <tr>
                            <th scope="col">
                                Produit
                            </th>
                            <th scope="col">
                                Prix Unitaire HT
                            </th>
                            <th scope="col">
                                Quantité
                            </th>
                            <th scope="col">
                                Montant Total HT
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let product of order.lstBillDetails">
                            <td>
                                {{product.product.labelP}}
                            </td>
                            <td>
                                {{product.product.amountP | number : '1.2-2'}}€
                            </td>
                            <td>
                                {{product.qty}}
                            </td>
                            <td>
                                {{product.product.amountP * product.qty}}€
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="col-7 offset-5">
                    <span class="font-weight-bold text-danger text-left">Total HT :</span>  <span class="right">{{order.amountHT | number : '1.2-2'}}€</span><br />
                    <div *ngIf="order.transStatus != 18 && order.transStatus != 17">
                        <span class="font-weight-bold text-danger text-left">Frais de livraison :</span>  <span class="right"> {{order.shipping | number : '1.2-2'}}€</span><br />
                    </div>
                    <div *ngIf="order.transStatus == 18 || order.transStatus == 17">
                        <span class="font-weight-bold text-danger text-left">Frais de livraison :</span>  <span class="right"> à déterminer</span><br />
                    </div>
                    <span class="font-weight-bold text-danger text-left">TVA :</span>  <span class="right">{{order.tva | number : '1.2-2'}}%</span><br />
                    <div *ngIf="order.transStatus != 18 && order.transStatus != 17">
                        <span class="font-weight-bold text-danger text-left">Total TTC :</span>  <span class="right">{{order.amountTotal | number : '1.2-2'}}€</span><br />
                    </div>
                    <div *ngIf="order.transStatus == 18 || order.transStatus == 17">
                        <span class="font-weight-bold text-danger text-left">Total TTC (Hors frais de ports) :</span>  <span class="right">{{order.amountTotal | number : '1.2-2'}}€</span><br />
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!devis" class="row">
            <hr class="col-12" />
            <div class="col-4 offset-2">
                <h3>   <i aria-hidden="true" class="fad fa-file-alt fa-1-2x " style=" --fa-primary-color: #e8641b ; --fa-secondary-color: #ef9c00;"></i> Code SAGE </h3>
                <form [formGroup]="sageForm" class="col-6">
                    <label for="unisite" class="font-weight-bold"> <span class="font-weight-bold"> Code SAGE : </span> </label>
                    <input type="text" class="ml-2" formControlName="sageCode">
                </form>
            </div>
            <div class="col-6">
                <h3>   <i aria-hidden="true" class="fad fa-file-alt fa-1-2x " style=" --fa-primary-color: #009236 ; --fa-secondary-color: #22b431;"></i> Numéro de facture </h3>
                <form [formGroup]="invoiceForm" class="col-6">
                    <label for="unisite" class="font-weight-bold"> <span class="font-weight-bold"> Numéro de facture : </span> </label>
                    <input type="text" class="ml-2" formControlName="invoiceCode">
                </form>
            </div>
        </div>
        <div *ngIf="facturation" class="text-center col-12">
            <button class="btn btn-success" (click)="sendInvoiceCode()"> Enregistrer </button>
        </div>
        <div *ngIf="devis" class="text-center col-12">
            <hr class="col-12" />
            <h3>   <i aria-hidden="true" class="fad fa-file-alt fa-1-2x " style=" --fa-primary-color: #e8641b ; --fa-secondary-color: #ef9c00;"></i> Montant des frais de port calculé</h3>
            <form [formGroup]="fdpDevisForm" class="col-6">
                <label for="fdpDevis" class="font-weight-bold"> <span class="font-weight-bold"> frais de port (HT) : </span> </label>
                <input name="fdpDevis" type="number" class="ml-2" formControlName="fdpDevis">
            </form>
            <div class="col-12 text-center mt-3">
                <span class="font-italic"> Si le devis est validé, cliquez sur le bouton valider ci-dessous </span>
            </div>
            <button class="btn btn-success" (click)="sendShippingFees()"> Valider le devis </button>
        </div>
        <div *ngIf="payement">
            <div class="col-12 text-center mt-3">
                <span class="font-italic"> Si le paiement a été envoyé et validé, cliquez sur le bouton accepter ci-dessous </span>
            </div>
            <div class="col-12">
                <div class="col-2 mx-auto">
                    <button class="btn btn-success btn-lg" (click)="validatePayement(order.billingID)"> Valider </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="shippingModal" class="modal">
    <div class="sending modal-content">
        <span class="text-right pointer close" (click)="closeShippingModal();">
            <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
        </span>
        <div class="text-center mt-5">
            <div> La commande est prête à être envoyée.</div>
            <div> Veuillez appuyer sur le bouton envoyer pour notifier le client. </div>
            <button class="btn btn-success btn-lg" (click)="notifySending()"> Valider </button>
        </div>
    </div>
</div>
